<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-12">{{ $t('title') }}</div>
    <div v-if="!portfolioAssets.length" class="text-center text-lg font-medium text-text">
      {{ $t('emptyStructure') }} 😴
    </div>
    <PortfolioStructureList v-else :portfolio-assets="portfolioAssets"/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import PortfolioStructureList
  from "@/components/cabinet/Investments/Dashboard/PortfolioStructure/PortfolioStructureList";

export default {
  name: "PortfolioStructure",
  components: {PortfolioStructureList, TopGradientBlockLayout},
  props: ['portfolioAssets'],
  i18n: {
    messages: {
      en: {
        title: 'Portfolio structure',
        emptyStructure: 'Your portfolio is empty'
      },
      ru: {
        title: 'Состав портфеля',
        emptyStructure: 'Ваш портфель пока пустой'
      }
    }
  }
}
</script>